import { Component, computed, inject, input, output } from '@angular/core';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { FileTypeLabelComponent } from 'common/files/file-type-label.component';
import { AggregatedProvidedEvidence, EvidenceFilterType } from 'api';
import { TranslateModule } from '@ngx-translate/core';
import { HighlightMatchesPipe } from 'common/search/highlight-matches.pipe';
import { DownloadService } from 'common/files/download.service';
import { IconDirective } from 'common/icon/icon.directive';

@Component({
  selector: 'comp-evidence-results',
  templateUrl: './evidence-results.component.html',
  styleUrls: ['./evidence-results.component.scss'],
  imports: [
    DatePipe,
    FileTypeLabelComponent,
    TranslateModule,
    HighlightMatchesPipe,
    NgTemplateOutlet,
    IconDirective,
  ],
})
export class EvidenceResultsComponent {
  downloadService = inject(DownloadService);

  evidences = input.required<AggregatedProvidedEvidence[]>();
  recommended = computed<AggregatedProvidedEvidence[]>(() =>
    this.evidences().filter((evidence) => evidence.recommended),
  );
  other = computed<AggregatedProvidedEvidence[]>(() =>
    this.evidences().filter((evidence) => !evidence.recommended),
  );
  selectedEvidence = input<AggregatedProvidedEvidence | undefined>(undefined);

  evidenceFilter = input.required<EvidenceFilterType>();
  searchText = input.required<string>();

  select = output<AggregatedProvidedEvidence | undefined>();

  toggleSelected(evidence: AggregatedProvidedEvidence) {
    this.select.emit(this.selectedEvidence()?.id === evidence.id ? undefined : evidence);
  }
}
